import React, { useEffect, useState } from "react";
import MainLayout from "../../components/common/layout/main/MainLayout";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import withAuth from "../../hocs/withAuth";
import CategoryBase from "./CategoryBase";
import { CategoryType } from "../../types/category.type";
import { categories } from "../../utils/category";

function CategoryPage() {
  const { code } = useParams();
  const [category, setCategory] = useState<CategoryType>();

  useEffect(() => {
    if (code) {
      const currentCate = categories[code];
      setCategory(currentCate);
    }
  }, [code]);

  return (
    <MainLayout>
      {category ? (
        <CategoryBase category={category} />
      ) : (
        <Typography sx={{ textAlign: "center", fontSize: "20px" }}>
          Danh mục không tồn tại
        </Typography>
      )}
    </MainLayout>
  );
}

export default withAuth(CategoryPage);
